import { AuthenticationLifeCycle, useAuthManagerFromContext } from './useAuthManagerFromContext'

export function useAuthStatus(): AuthenticationLifeCycle {
  const authManager = useAuthManagerFromContext()
  return authManager.authState
}
